import { useEffect, useState } from "react";

import { transformChurnDataToSeries } from "./constants";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useChurnReport = () => {
    const { platformId } = useParams();
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const [data, setData] = useState({
        chart: {
            categories: [],
            series    : []
        },
        widgets: {
            totalChurned    : 0,
            averageChurnRate: 0
        }
    });
    
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();

    const getChurnReport = async () => {
        const { data } = await axiosInstance.get(`/report/${platformId}/churn`, {
            params: {
                start: getSearchParams("start"),
                end  : getSearchParams("end"),
                ...queryParams
            }
        });

        const reportData = data?.report || [];
        const widgetData = data?.widget || {};

        const chartData = transformChurnDataToSeries(reportData);
            
        setData({
            chart  : chartData,
            widgets: {
                totalChurned    : widgetData.total_churned || 0,
                averageChurnRate: widgetData.average_churn_rate || 0
            }
        });

    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getChurnReport();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        loading,
        data,
        setQueryParams,
        getChurnReport
    };
};

export default useChurnReport;